import { normalizeTag, canManuallyEnroll } from './campaignTriggers';
import { canMessageLead } from '../shared/leadPermissions';
import { canSeeRecord } from './recordAccess';

// Bulk "Add hashtag": any lead the user can see. Returns { tags } patches for leads that don't have it yet.
export const tagLabel = (raw) => { const t = String(raw || '').trim().replace(/^#+/, '').replace(/\s+/g, ' '); return t ? `#${t}` : ''; };
export function planBulkHashtag(contacts, rawTag, uid, isAdmin) {
  const tag = tagLabel(rawTag); const key = normalizeTag(tag);
  if (!key) return { tag: '', updates: [], already: 0, skipped: 0 };
  const updates = []; let already = 0; let skipped = 0;
  for (const c of contacts || []) {
    if (!c || !canSeeRecord(c, uid, isAdmin)) { skipped += 1; continue; }
    const tags = Array.isArray(c.tags) ? c.tags : [];
    if (tags.some((t) => normalizeTag(t) === key)) { already += 1; continue; }
    updates.push({ contact: c, tags: [...tags, tag] });
  }
  return { tag, updates, already, skipped };
}

// Bulk "Add to campaign": only leads this user may email (assigned, or owned + entered by them; admins all),
// that the campaign accepts, and that aren't already in it. Everything else is skipped and counted.
export function planBulkEnroll(campaign, contacts, uid, isAdmin, enrollments = []) {
  const inIt = new Set((enrollments || []).filter((e) => e && e.campaignId === campaign?.id && e.status !== 'stopped_excluded').map((e) => e.contactId));
  const go = []; const why = { notAllowed: 0, notEligible: 0, already: 0 };
  for (const c of contacts || []) {
    if (!canMessageLead(c, uid, isAdmin)) why.notAllowed += 1;
    else if (!canManuallyEnroll(campaign, c)) why.notEligible += 1;
    else if (inIt.has(c.id)) why.already += 1;
    else go.push(c);
  }
  return { go, skipped: why.notAllowed + why.notEligible + why.already, why };
}
